import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PRICING } from "@/lib/content";

export const StickyCta = ({ watchRef }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = watchRef.current;
    if (!el || !("IntersectionObserver" in window)) return;
    const io = new IntersectionObserver(([e]) => setShow(!e.isIntersecting && e.boundingClientRect.top < 0), {
      threshold: 0,
    });
    io.observe(el);
    return () => io.disconnect();
  }, [watchRef]);

  useEffect(() => {
    document.body.classList.toggle("has-sticky-cta", show);
    return () => document.body.classList.remove("has-sticky-cta");
  }, [show]);

  return (
    <div
      aria-hidden={!show}
      data-testid="sticky-mobile-cta"
      className={`fixed inset-x-0 bottom-0 z-40 sm:hidden border-t border-divider bg-white/95 backdrop-blur-md px-5 pt-3 safe-bottom shadow-[0_-6px_24px_-12px_rgba(22,59,48,0.18)] transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="leading-tight min-w-0">
          <p className="text-sm font-semibold text-ink truncate">${PRICING.base.toLocaleString()} · ${PRICING.deposit} deposit</p>
          <p className="text-xs text-sec">Lab fees included</p>
        </div>
        <Link to="/book" className="btn-primary !w-auto !py-2.5 !min-h-[48px] !px-5 !text-sm shrink-0" tabIndex={show ? 0 : -1} data-testid="sticky-book-cta">
          Reserve — ${PRICING.deposit}
          <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
};
